/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJswConfigurationType from '@jira/spa-apps__admin-pages-products-jsw-configuration/src/ProductsJswConfigurationType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJswConfiguration: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProductsJswConfigurationType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsw-configuration", jiraSpaEntry: "async-products-jsw-configuration" */ '@jira/spa-apps__admin-pages-products-jsw-configuration/src/ProductsJswConfigurationType.tsx'
		),
	),
);

const AsyncProductsJswConfiguration = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJswConfiguration}
		pageId="products-jsw-configuration"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJswConfiguration;
